import React, {useState, useEffect, useRef} from 'react';
import {Theme, FormControl} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import Button from '../components/custom-button';
import RoleRadio from '../components/role-radio';
import Icon from '../components/icon';
import FormInput from '../components/form-input';
import FormSelect from '../components/form-select';
import {isElectron} from '../utils/platform';
import {usePlatform} from '../containers/platform-container';
import {useHistory} from 'react-router-dom';
import {roomStore} from '../stores/room';
import {genUid} from '../utils/helper';
import MD5 from 'js-md5';
import {globalStore} from '../stores/global';
import {sfAjax} from "../utils/custom_api";
import useChatText from "../hooks/use-chat-text";

export const roomTypes = [
    {value: 0, text: 'Large Class', path: 'big-class'},
];

const useStyles = makeStyles((theme: Theme) => ({
    formControl: {
        minWidth: '240px',
        maxWidth: '240px',
    }
}));

type SessionInfo = {
    roomName: string
    roomType: number
    yourName: string
    role: string
}

const defaultState: SessionInfo = {
    roomName: '',
    roomType: 0,
    role: '',
    yourName: '',
}

function HomePage() {
    const {sendMessage} = useChatText();
    const [loginImg, setLoginImg] = useState('');
    const [clientId, setclientId] = useState('');

    let resultMsg: any = null
    const classes = useStyles();

    const history = useHistory();

    const handleSetting = (evt: any) => {
        history.push({pathname: `/device_test`});
    }
    const getLiveQrCode = (client_id: string) => {
        setclientId(client_id)
        // 获取声网rtmtoken
        sfAjax.get('expert/api.Expert/getLiveQrCode', {
            client_id: client_id
        }).then((res: any) => {
            if (res.code == 1) {
                console.log(res)
                setLoginImg(res.data.url)
            } else {

            }
        }).catch(err => {

        })
    }

    const bindRoom = (obj:any) => {
        sfAjax.post('expert/api.Expert/liveBind', obj).then((res: any) => {
            if (res.code == 1) {
                console.log(res)
            } else {

            }
        }).catch(err => {

        })
    }

    const socketMsg = globalStore.state.mySocket.message
    useEffect(() => {
        switch (socketMsg.type) {
            case 'init':
                getLiveQrCode(socketMsg.client_id)
                window.localStorage.removeItem('userInfo')
                break;
            case 'pc_live':
                // 扫码成功
                resultMsg = socketMsg.data
                window.localStorage.setItem('userInfo', JSON.stringify(resultMsg.member))
                bindRoom({
                    client_id: clientId,
                    live_id: resultMsg.channel_id
                })
                handleSubmit()
                break;
        }
    }, [socketMsg])


    const {
        HomeBtn
    } = usePlatform();

    const ref = useRef<boolean>(false);

    useEffect(() => {
        return () => {
            ref.current = true;
        }
    }, []);

    const [session, setSessionInfo] = useState<SessionInfo>(defaultState);

    const [required, setRequired] = useState<any>({} as any);

    const handleSubmit = () => {
        if (!roomTypes[session.roomType]) return;
        const path = roomTypes[session.roomType].path
        let userInfo = resultMsg
        let payload = {
            uid: userInfo.uid.toString(),
            rid: userInfo.channel_id,
            role: 'teacher',
            roomName: userInfo.live.title,
            roomType: session.roomType,
            video: 1,
            audio: 1,
            chat: 1,
            account: userInfo.member.user_name,
            token: '',
            boardId: '',
            linkId: 0,
            sharedId: 0,
            lockBoard: 0,
        }
        ref.current = true;
        globalStore.showLoading();
        // 获取声网rtmtoken
        sfAjax.get('expert/api.Expert/agoraRtmToken', {
            uid: payload.uid
        }).then((res: any) => {
            if (res.code == 1) {
                payload.token = res.data
                joinSfRoom(payload, path)
            } else {
                ref.current = false;
                globalStore.stopLoading();
            }
        }).catch(err => {
            ref.current = false;
            globalStore.stopLoading();
        })

    }

    /***
     * 获取当前浏览器类型
     */
    function myBrowser() {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
        var isOpera = userAgent.indexOf("Opera") > -1;
        if (isOpera) { //判断是否Opera浏览器
            return "Opera"
        }
        ;
        if (userAgent.indexOf("Firefox") > -1) { //判断是否Firefox浏览器
            return "FF";
        }
        ;
        if (userAgent.indexOf("Chrome") > -1) {
            return "Chrome";
        }
        ;
        if (userAgent.indexOf("Safari") > -1) { //判断是否Safari浏览器
            return "Safari";
        }
        ;
        if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) { //判断是否IE浏览器
            return "IE";
        }
        ;
    }

    const joinSfRoom = (payload: any, path: string) => {
        roomStore.loginAndJoin(payload).then(() => {
            roomStore.updateSessionInfo(payload);
            history.push(`/classroom/${path}`);
        }).catch((err: any) => {
            if (err.reason) {
                globalStore.showToast({
                    type: 'rtmClient',
                    message: err.reason
                })
            } else {
                globalStore.showToast({
                    type: 'rtmClient',
                    message: 'login failure, please checkout ur network'
                })
            }
            console.warn(err);
        }).finally(() => {
            ref.current = false;
            globalStore.stopLoading();
        })
    }

    return (
        <div className={`flex-container ${isElectron ? 'draggable' : 'home-cover-web'}`}>
            {isElectron ? null :
                <div className="web-menu">
                    <div className="web-menu-container">
                        <div className="short-title">
                            <span className="title">12396农牧业科技服务</span>
                            <span className="subtitle">直播平台</span>
                        </div>
                        <Icon className="icon-setting" onClick={handleSetting}/>
                    </div>
                </div>
            }
            <div className="user-code">
                <img className="scan-code" src={loginImg} alt=""/>
                <p className="scan-tips">请用小程序直播间扫码登录</p>
            </div>
            <div className="chrome-tips">温馨提醒：为避免使用异常，请使用最新版本谷歌浏览器（Google Chrome）</div>
        </div>
    )
}

export default React.memo(HomePage);
